import { BadgeCheck, Music, Palette, BookOpen } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PublicLayout";
import { BookButton } from "@/components/site/Header";

const VALUES = [
  { icon: Music, title: "Müzikle büyümek", text: "[Akademinizin müzik eğitimine yaklaşımını anlatan kısa metin.]" },
  { icon: Palette, title: "Sanatla ifade", text: "[Sanat dallarındaki hedeflerinizi anlatan kısa metin.]" },
  { icon: BookOpen, title: "Masalla öğrenmek", text: "[Masal temalı öğrenme anlayışınızı anlatan kısa metin.]" },
];

export default function About() {
  return (
    <>
      <Seo title="Hakkımızda" description="Masal Sanat Akademi hakkında: M.E.B. onaylı özel sanat akademisi." />
      <PageHero eyebrow="Hakkımızda" title="Masal Sanat Akademi">
        M.E.B. onaylı özel bir sanat akademisiyiz. [Kuruluş hikâyenizi ve misyonunuzu anlatan metin buraya gelecek.]
      </PageHero>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <img src="/images/piyano.jpg" alt="Piyano dersi" className="w-full aspect-[4/5] object-cover rounded-[2.5rem]" />
        </div>
        <div className="lg:col-span-7 space-y-6">
          <span className="inline-flex items-center gap-2 rounded-full bg-bej px-4 py-2 text-sm font-bold text-navy"><BadgeCheck className="w-4 h-4" /> M.E.B. onaylı</span>
          {VALUES.map((v) => (
            <div key={v.title} className="flex gap-4 rounded-3xl border border-bej p-6">
              <div className="grid place-items-center w-12 h-12 shrink-0 rounded-2xl bg-navy text-white"><v.icon className="w-5 h-5" /></div>
              <div>
                <h2 className="font-heading text-xl font-extrabold text-navy">{v.title}</h2>
                <p className="mt-1 text-slate-600">{v.text}</p>
              </div>
            </div>
          ))}
          <BookButton testid="about-book-btn" className="px-7 py-3.5" />
        </div>
      </section>
    </>
  );
}
